<template>
  <v-touch class="day-cal__overlay" :style="{height: height + 'px'}">
    <div class="cal-wrapper" :style="{height: calHeight + 'px'}">
      <DCalendar
        :key="activeDate + '_' + locale"
        :isEditable="false"
        :isShowWeekends="isShowWeekends"
        :startTime="startTime"
        :endTime="endTime"
        :date="activeDate"
        :events="lessons"
        :calendarId="calId"
        :isEventsClickable="true"
        :localeOverride="locale"
        @onEventClick="onTap">
      </DCalendar>
    </div>
    <!-- Weekplan -->
    <div class="pad-10 weekplan-header marg-20-top">
      <span class="date">{{calRangeView}}</span>
      <h2>{{ $t('calendars.week_plan_and_note.week_plan')}}</h2>
    </div>
    <weekplan class="pad-10"
              :weeknote="weeknote"
              :calId="calId"
              :date="date"
              :events="lessons">
    </weekplan>
  </v-touch>
</template>

<script>
  import DCalendar from '../../../DCalendar/DCalendar'
  import weekplan from '../WeekPlan/WeekPlan.vue'
  import moment from 'moment'

  export default {
    props: ['lessons', 'date', 'dateChange', 'viewState', 'calId', 'weeknote', 'locale', 'i18n'],
    components: {DCalendar, weekplan},
    computed: {
      activeDate () {
        return moment(this.date).locale('en').format('YYYY-MM-DD')
      },
      startTime () {
        var state = this.viewState * 1
        if (state === 2) return '00:00:00'
        return '06:00:00'
      },
      endTime () {
        var state = this.viewState * 1
        if (state === 2) return '23:00:00'
        return '18:00:00'
      },
      isShowWeekends () {
        var state = this.viewState * 1
        return state > 0
      },
      calHeight () {
        // Beregn højde til DCalendar baseret på tidsrummet
        var startHour = parseInt(this.startTime)
        var endHour = parseInt(this.endTime)
        var hours = endHour - startHour
        var headerHeight = 50
        // Hver halve time er ca 20px
        return headerHeight + (hours * 2 * 20)
      },
      calRangeView () {
        let s = moment(this.date).locale(this.locale || 'da').isoWeekday(1)
        let e = moment(this.date).locale(this.locale || 'da').isoWeekday(7)
        let start = s.format('DD.')
        let start2 = s.format('DD. MMM')
        let end = e.format('DD. MMM YYYY')
        // If same month
        if (s.format('MM') === e.format('MM')) {
          return start + ' - ' + end
        } else {
          return start2 + ' - ' + end
        }
      }
    },
    data () {
      return {
        height: 300
      }
    },
    methods: {
      onTap (event) {
        var eventData = event.obj || event
        this.$emit('eventClicked', eventData)
      },
      calculateHeightForCalendar () {
        let windowHeight = window.innerHeight
        this.height = windowHeight - 55 - 55
      },
      setScrollTop (val) {
        this.$el.scrollTop = val.top - 20
      }
    },
    mounted () {
      window.addEventListener('resize', () => {
        this.calculateHeightForCalendar()
      })
      this.calculateHeightForCalendar()
    }
  }
</script>

<style scoped>
  .day-cal__overlay {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .cal-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 250px;
    width: 600px;
  }

</style>



// WEBPACK FOOTER //
// CalContainer.vue?8d837f9a